import * as Sentry from "@sentry/react";

import { CONFIG } from "./utils/config";

if (CONFIG.SENTRY_DSN !== "missing") {
  Sentry.init({
    dsn: CONFIG.SENTRY_DSN,
    environment: CONFIG.MODE,
  });
} else {
  console.log("Sentry disabled");
}
